import { footer } from '../content/site';
import logo from '../assets/beamon-logo.svg';

export default function Footer() {
  return (
    <footer className="bg-dusk-deep py-10 text-cream/70">
      <div className="container-page flex flex-col items-center justify-between gap-4 sm:flex-row">
        <a href="#top" className="flex items-center gap-2 font-display text-cream">
          <img src={logo} alt="" aria-hidden className="h-6 w-6 rounded-md" width={24} height={24} />
          {footer.companyName}
        </a>
        <p className="text-sm">{footer.tagline}</p>
        <p className="text-xs text-cream/50">
          © {new Date().getFullYear()} {footer.companyName}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
